"use client";

import { useState, useEffect } from "react";

export const Reactions = ({
  title,
  emoji,
  count,
  id,
  onReactionAdded,
  isActive = false,
}: {
  title: string;
  count: number;
  emoji: any;
  id: string;
  onReactionAdded?: () => void;
  isActive?: boolean;
}) => {
  // Use null initially to avoid hydration mismatch
  const [mounted, setMounted] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  // Set the mounted flag after client-side hydration is complete
  useEffect(() => {
    setMounted(true);
  }, []);

  // Handle click on the emoji
  const handleClick = () => {
    if (!mounted || isLoading) return;

    setIsLoading(true);

    try {
      // Notify parent component to update UI
      if (onReactionAdded) {
        onReactionAdded();
      }

      // Loading will be cleared by the parent component
    } catch (error) {
      console.error("Error in reaction component:", error);
    }
  };

  // Get appropriate background color based on active state
  const getBgClass = () => {
    if (isLoading) return "bg-foreground-200";
    if (isActive) return "bg-primary-100 dark:bg-primary-900/30";
    return "bg-foreground-100";
  };

  // Get appropriate text color based on active state
  const getTextClass = () => {
    if (isActive) return "text-primary-600 dark:text-primary-300";
    return "";
  };

  // Simplified render with actual count from parent
  return (
    <div
      key={title}
      className={`flex cursor-pointer items-center space-x-1 rounded-full ${getBgClass()} px-2 py-1 text-sm transition-colors hover:ring-1 hover:ring-foreground-300 ${getTextClass()}`}
      onClick={handleClick}
    >
      <span>{emoji}</span>
      <span>{count}</span>
    </div>
  );
};
